import { render, staticRenderFns } from "./MaterialesTable.vue?vue&type=template&id=5b49f134&scoped=true&"
import script from "./MaterialesTable.vue?vue&type=script&lang=js&"
export * from "./MaterialesTable.vue?vue&type=script&lang=js&"
import style0 from "./MaterialesTable.vue?vue&type=style&index=0&id=5b49f134&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b49f134",
  null
  
)

export default component.exports